import Vue from 'vue'
import Vuex from 'vuex'

import * as types from '../../mutation-types'
import translationAPI from '../../../api/translations'
import vuexI18n from 'vuex-i18n'

Vue.use(Vuex)
Vue.use(vuexI18n.plugin, new Vuex.Store())

const state = {
  language: localStorage.getItem('language') || 'en',
  languages: {
    'en': {
      translations: require('./en.json'),
      dir: 'ltr',
      order: 1
    },
    'ar': {
      translations: require('./ar.json'),
      dir: 'rtl',
      order: 2
    },
    'ur': {
      translations: require('./ur.json'),
      dir: 'rtl',
      order: 3
    },
    'gu': {
      translations: require('./gu.json'),
      dir: 'ltr',
      order: 4
    },
    'bn': {
      translations: require('./bn.json'),
      dir: 'ltr',
      order: 5
    }
  }
}

for (let ln in state.languages) {
  Vue.i18n.add(ln, state.languages[ln].translations)
}

Vue.i18n.set(state.language)
Vue.i18n.fallback('en')

// getters
const getters = {
  language: (state) => state.language,
  languages: (state) => Object.keys(state.languages).sort((a, b) => state.languages[a].order > state.languages[a].order),
  dir: (state) => state.languages[state.language].dir
}

const actions = {
  changeLanguage ({commit}, lang) {
    commit(types.CHANGE_LANGUAGE, {lang})
  },
  loadTranslations ({commit}) {
    return new Promise((resolve, reject) => {
      translationAPI.getTranslations()
        .then((a) => {
          // commit(types.LOAD_TRANSLATIONS)
          commit(types.LOAD_TRANSLATIONS, a.data)
          // if (a.status === 'Success') {
          //   commit(types.LOAD_TRANSLATIONS_SUCCESS, a)
          //   resolve(a)
          // } else {
          //   commit(types.LOAD_TRANSLATIONS_FAILED, a)
          //   reject(a)
          // }
        })
        .catch((reason) => {
          // commit(types.LOAD_TRANSLATIONS_FAILED, reason)
          reject(reason)
        })
        .finally(() => {
        })
    })
  }
}

const mutations = {
  [types.CHANGE_LANGUAGE] (state, {lang}) {
    state.language = lang
    Vue.i18n.set(lang)
    localStorage.setItem('language', lang)
  },
  [types.LOAD_TRANSLATIONS] (state, a) {
    Object.keys(a).map((lang) => {
      Vue.i18n.add(lang, a[lang])
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/i18n/index.js